import type { BlockRecord } from '@/lib/blocks/types';
import { queryNavBlocks, queryNavChildren } from '@/lib/db/queries';
import { getLastSeq } from '@/lib/db/shared';
import { getSyncEngine } from '@/lib/sync/engine';

/**
 * Read the sidebar tree from local SQLite.
 * When a snapshot is already stored, this does not wait for network catchup.
 */
export async function loadSidebarNavBlocks(): Promise<BlockRecord[]> {
  const engine = getSyncEngine();
  const database = await engine.openLocalDatabase();
  const lastSeq = await getLastSeq(database);
  if (lastSeq === 0) {
    await engine.start();
  }
  return queryNavBlocks(database);
}

export async function reloadSidebarNavBlocks(): Promise<BlockRecord[]> {
  const engine = getSyncEngine();
  const database = engine.getDatabase() ?? (await engine.openLocalDatabase());
  return queryNavBlocks(database);
}

export async function loadSidebarNavChildren(parentId: string): Promise<BlockRecord[]> {
  const engine = getSyncEngine();
  const database = engine.getDatabase() ?? (await engine.openLocalDatabase());
  return queryNavChildren(database, parentId);
}
